import React, { Component } from 'react';
import { dateFormatGMT, formatPrice, getHoursDateGMT, getPurchasePending } from '../../utils';
import CashTransferInstruction from './CashTransferInstruction';
import StatusPayment from './StatusPayment';


export default class StatusSafetypay extends Component {

    render() {
        const { purchase } = this.props;
        return (
            <StatusPayment purchase={purchase}>
                <div className="safetypay">
                    <div className="payment-safetypay">
                        <div className="bank">
                            <img
                                src={purchase.payment.bank_img_path}
                                alt="bank"
                                width="30px"
                            />
                        </div>
                        <div className="infos-safetypay">
                            <span>{purchase.payment.bank_name}</span> <br />
                            <strong>Total</strong> R$ {formatPrice(purchase.price)}
                        </div>
                    </div>

                    {getPurchasePending(purchase.status) ?
                        <div className="warning-safetypay-deadline">
                            {purchase.payment.active_safetypay &&
                                <React.Fragment>
                                    <strong>Atenção:</strong> A compra somente será concluída se o pagamento for realizado até as {getHoursDateGMT(purchase.payment.active_safetypay.deadline)}h do dia <strong>{dateFormatGMT(purchase.payment.active_safetypay.deadline)}</strong>
                                </React.Fragment>
                            }
                        </div>
                        : purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ?
                            <div className="warning-safetypay-deadline">
                                <strong>Atenção:</strong> As informações para realizar a transferência bancária estão disponíveis no seu e-mail.
                            </div>

                            : <div />
                    }
                    {purchase.payment.active_safetypay && (
                        <React.Fragment>

                            {purchase.payment.active_safetypay.extra ? (
                                <div>
                                    <div className="warning-instructions">
                                        <strong> Siga as intruções abaixo e garanta sua reserva:  </strong>
                                    </div>
                                    <CashTransferInstruction purchase={purchase} />
                                </div>
                            ) : (
                                <div className="warning-instructions">
                                    <strong>Atenção:</strong> As informações para realizar a transferência bancária estão disponíveis no seu e-mail.
                                </div>
                            )}


                        </React.Fragment>
                    )}

                    {purchase.status !== 'Aprovado' || purchase.status !== 'Reprovado' || purchase.status !== 'Cancelado' ?
                        <div className="help">
                            <strong>Importante:</strong>

                            <div className="help-steps">
                                <img src="/assets/images/mail/cash.png" alt="cash" />
                                <span>Transfira o valor exato da sua compra: R$ {formatPrice(purchase.price)}</span>
                            </div>
                            <div className="help-steps">
                                <img src="/assets/images/mail/forbidden.png" alt="pj" />
                                <span>Não utilize contas de Pessoa Jurídica;</span>
                            </div>
                            <div className="help-steps">
                                <img src="/assets/images/mail/forbidden.png" alt="not-account" />
                                <span>Não utilize Conta Poupança;</span>
                            </div>
                            <div className="help-steps">
                                <img src="/assets/images/mail/forbidden.png" alt="internet-banking" />
                                <span>Pague somente por meio do Internet Banking do banco acima. Não disponível para caixa eletrônico, telefone ou pela agência bancária.</span>
                            </div>
                            <div className="help-steps">
                                <img src="/assets/images/mail/deadline.png" alt="payment-date" />
                                <span>O pagamento deverá ser realizado dentro do prazo estabelecido para que seja reconhecido como válido. Não agende o pagamento para outra data.</span>
                            </div>
                        </div>

                        : <div />
                    }
                </div>
            </StatusPayment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusSafetypay.jsx